export enum DbTable {
    None = 0,
    Any = 10,
    Dispatch = 100,
    DispatchStatus = 101,
    DispatchAssignments = 109,
    DispatchLabor=110,
    Quote = 200,
    Orders = 300,
    Invoices = 300,
    InvoiceLines = 301,
    Contracts = 400,
    Jobs = 410
}
